import {
	Typography as TypographyMui,
	TypographyProps as TypographyPropsMui,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Tooltip from 'styles/tooltip/Tooltip';

interface IDynamicTypography {
	maxWidth: number;
}

type TypographyProps = TypographyPropsMui & IDynamicTypography;

const StyledTypography = styled(TypographyMui)({
	lineHeight: '16px!important',
});

const DynamicTypography = (props: TypographyProps) => {
	const { maxWidth } = props;

	const [width, setWidth] = useState<number>(0);
	const ref = useRef<any>(null);

	const MAX_WIDTH_TEXT = maxWidth * 2 - 20;

	useEffect(() => {
		if (ref.current.offsetWidth && width === 0) {
			setWidth(ref.current.offsetWidth);
		}
	}, [ref.current?.offsetWidth, width]);

	return (
		<Tooltip
			title={width > MAX_WIDTH_TEXT ? props.children : ''}
			placement="right"
		>
			<StyledTypography
				{...props}
				ref={ref}
				sx={{
					whiteSpace: width <= maxWidth ? 'nowrap' : 'wrap',
					...(width > MAX_WIDTH_TEXT
						? {
								display: '-webkit-box',
								WebkitLineClamp: 2,
								WebkitBoxOrient: 'vertical',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								maxWidth,
						  }
						: {}),
				}}
			>
				{props.children}
			</StyledTypography>
		</Tooltip>
	);
};

export default DynamicTypography;
